import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ErrorHandlerService {
  constructor() { }

  handlerEror(error) {
    console.log(error);
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/services/error.handler.service.ts